import {useState} from "react"
import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import SubPlayer from "../../SubPlayer/SubPlayer"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import {useTranslation} from "react-i18next"
import {toast} from "react-toastify"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import isLicenceValidity from "../../tools/isLicenceValidity"
import useStProjectSource from "../../swrCustomHooks/useStProjectSource"
import useStProjectWaveform from "../../swrCustomHooks/useStProjectWaveform"
import useStTranscription from "../../swrCustomHooks/useStTranscription"

export default function StWorkflowTranscription({project, setIsPulling, langCode}) {
    const {t} = useTranslation()
    const {sessionContext, setSessionAction} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {stProjectSource, isLoadingStProjectSource, isErrorStProjectSource} = useStProjectSource(project.id)
    const {stProjectWaveform, isLoadingStProjectWaveform, isErrorStProjectWaveform} = useStProjectWaveform(project.id, sessionContext.idToken, setSessionAction)
    const {stProjectTranscription, isLoadingStProjectTranscription, isErrorStProjectTranscription} = useStTranscription(project.id)
    const [latestSrt, setLatestSrt] = useState()
    const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}

    const save = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            axios.put(`${API_PROJECTS}/${project.id}/transcription`, latestSrt, headersRequest)
            .then(() => {
                toast.success(t("Subtitles saved!"), {containerId: "subplayer"})
            })
            .catch((err) => {
                toast.error(t("An error has occurred"), {containerId: "subplayer"})
                console.error("error :", err)
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."), {containerId: "subplayer"})
        }
    }

    const translate = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            axios.put(`${API_PROJECTS}/${project.id}/transcription`, latestSrt, headersRequest)
            .then(() => {
                axios.post(`${API_PROJECTS}/${project.id}/tries`, {step: "translation", lang_codes: [langCode]}, headersRequest)
                .then((response) => {
                    if (response.data.message === `maximun number of tries for "translation" has been reached or exceeded`) {
                        toast.warning(t("The maximum number of translation(s) has been reached or exceeded!"))
                    }
                    setIsPulling(true)
                })
                .catch((error) => {
                    console.error(`POST /projects/${project.id}/tries:`, error)
                })
            })
            .catch((error) => {
                console.error(`PUT /projects/${project.id}/transcription:`, error)
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    if (isErrorStProjectSource || isErrorStProjectTranscription ||
        isLoadingStProjectSource || isLoadingStProjectTranscription ||
        stProjectSource.message || stProjectTranscription.message) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION ST-WORKFLOW-TRANSCRIPTION">
            <SubPlayer project={project}
                mediaUrl={stProjectSource}
                waveformUrl={stProjectWaveform}
                isLoadingWaveform={isLoadingStProjectWaveform}
                isErrorWaveform={isErrorStProjectWaveform}
                srtFile={stProjectTranscription}
                setLatestSrt={setLatestSrt}
                save={save}
            />
            {!project.finished &&
                <div className="actions">
                    <button onClick={translate} title={t("Translate")}>{t("Translate")}</button>
                </div>
            }
        </div>
        </>
    )
}
